import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { DETALLES } from '../../data/retiro';
export function Detalles() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(176,146,191,0.08)'
  }} data-id="element-95" data-mp="1zh6y72288sgv">
      <div className="mx-auto max-w-5xl" data-id="element-96" data-mp="24h1n502fz7za">
        <SectionHeading eyebrow="Todo lo que incluye tu experiencia" title="Los detalles del encuentro" data-id="element-97" data-mp="28hvbtvnpkqt8" />

        <div className="mt-14 overflow-hidden rounded-3xl border bg-white/70" style={{
        borderColor: 'rgba(200,153,46,0.2)'
      }} data-id="element-98" data-mp="2dg6kw466ixae">
          {DETALLES.map((d, i) => <Reveal key={d.aspecto} data-id="element-99" data-mp="2n5gfprsequ27" data-mpi={i}>
              <div className="flex flex-col gap-1 px-6 py-6 sm:flex-row sm:items-center sm:gap-8 sm:px-8" style={{
            borderTop: i === 0 ? 'none' : '1px solid rgba(42,36,32,0.08)'
          }} data-id="element-100" data-mp="2n8m22z9njhu8">
                <div className="flex items-center gap-3 sm:w-64 sm:shrink-0" data-id="element-101" data-mp="5mogl41ofst3">
                  <span className="text-2xl" data-id="element-102" data-mp="mk3lnzz9g7m">{d.emoji}</span>
                  <span className="font-medium" style={{
                color: 'var(--ink)'
              }} data-id="element-103" data-mp="3rt4sp26h2e20">
                    {d.aspecto}
                  </span>
                </div>
                <p className="text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-104" data-mp="obv02taaoofy">
                  {d.detalle}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-105" data-mp="9myr8u0ez7ea">
          <p className="mt-8 text-center text-sm leading-relaxed" style={{
          color: 'rgba(42,36,32,0.7)'
        }} data-id="element-106" data-mp="9lnngu6yxzn6">
            ✨{' '}
            <strong style={{
            color: 'var(--darkgoldenrod)'
          }} data-id="element-107" data-mp="12a2v2vnrtfoh">
              Cupo limitado a 15 personas.
            </strong>{' '}
            Incluye rituales de apertura y cierre con presencia e intención,
            para marcar un antes y un después en tu historia.
          </p>
        </Reveal>
      </div>
    </section>;
}